import type React from 'react';
import { lazy } from 'react';
import { LazyDependency } from '../../../components/LazyDependency.tsx';
import type { AiExamplesEditorProps } from './AiExamplesEditor.tsx';

// Second @dnd-kit user besides the sheet editor — kept out of the initial bundle as well.
const LazyAiExamplesEditorImpl = lazy(() => import('./AiExamplesEditor.tsx').then(m => ({ default: m.AiExamplesEditor })));

export const LazyAiExamplesEditor: React.FC<AiExamplesEditorProps> = props => (
  <LazyDependency height="200px">
    <LazyAiExamplesEditorImpl {...props} />
  </LazyDependency>
);
